// test615
(615 && 0);
